export default __webpack_public_path__ + "static/soviet-wallpaper2-66dc7568c3c9fc2c4bec0086f0dbb9b4.jpeg";